(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nyna-intent-engine"] && !Shopify.designMode) return;
  try {
    (function() {
    // Utilities
    const log = (...args) => {
      if (window.NYNA_INTENT_DEBUG) console.log('[NYNA Intent]', ...args);
    };

    const throttle = (func, limit) => {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    };

    const STORAGE_KEY = 'nyna_intent_data';
    const SESSION_KEY = 'nyna_intent_shown';

    // State
    const state = {
      sessionStartTime: Date.now(),
      lastActivityTime: Date.now(),
      pageStartTime: Date.now(),
      lastCloseTime: sessionStorage.getItem('nyna_last_close') ? parseInt(sessionStorage.getItem('nyna_last_close')) : null,
      hasInteractedSinceClose: false,
      isModalOpen: false,
      data: {
        categories: {},
        products: {}
      },
      currentCategory: null,
      currentIntentLevel: 'LOW'
    };

    // 1 & 2. IntentTracker & IntentScore
    const IntentTracker = {
      init() {
        this.loadData();
        this.trackPageLoad();
        this.setupEventListeners();
      },

      loadData() {
        try {
          const stored = localStorage.getItem(STORAGE_KEY);
          if (stored) {
            state.data = JSON.parse(stored);
          }
        } catch (e) {
          log('Error loading data', e);
        }
        this.evaluateScore();
      },

      saveData() {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(state.data));
        } catch (e) {
          log('Error saving data', e);
        }
        this.evaluateScore();
      },

      addCategoryScore(category, points) {
        if (!category) return;
        if (!state.data.categories[category]) state.data.categories[category] = 0;
        state.data.categories[category] += points;
        log(`Added ${points} to category ${category}`);
      },

      addProductScore(handle, id, category, points) {
        if (!handle || !id) return;
        if (!state.data.products[handle]) {
          state.data.products[handle] = { id, category, score: 0, views: 0 };
        }
        state.data.products[handle].score += points;
        log(`Added ${points} to product ${handle}`);
      },

      trackPageLoad() {
        const pd = window.NYNA_INTENT_DATA;
        if (!pd) return;

        if (pd.pageType === 'collection' && pd.collection.title) {
          const cat = pd.collection.title;
          this.addCategoryScore(cat, 1);
          
          setTimeout(() => {
            this.addCategoryScore(cat, 2);
            this.saveData();
          }, 15000);
        } 
        else if (pd.pageType === 'product' && pd.product.handle) {
          const { handle, id, type } = pd.product;
          
          if (state.data.products[handle]) {
            this.addProductScore(handle, id, type, 5); // Revisit
            state.data.products[handle].views += 1;
          } else {
            this.addCategoryScore(type, 3);
            this.addProductScore(handle, id, type, 0); // Init
            state.data.products[handle].views = 1;
            
            // Check if viewed 3+ products in same category
            const productsInCat = Object.values(state.data.products).filter(p => p.category === type).length;
            if (productsInCat >= 3) {
              this.addCategoryScore(type, 4);
            }
          }
          
          setTimeout(() => {
            this.addCategoryScore(type, 3);
            this.addProductScore(handle, id, type, 3);
            this.saveData();
          }, 20000);
        }
        this.saveData();
      },

      setupEventListeners() {
        // Track Add to Cart as high intent
        document.body.addEventListener('click', (e) => {
          const btn = e.target.closest('form[action^="/cart/add"] button[type="submit"], .product-card__add-to-cart');
          if (btn) {
            const pd = window.NYNA_INTENT_DATA;
            if (pd && pd.product && pd.product.handle) {
              this.addProductScore(pd.product.handle, pd.product.id, pd.product.type, 15);
              this.saveData();
            }
          }
        });
      },

      evaluateScore() {
        // Find top category
        let topCat = null;
        let maxCatScore = 0;
        for (const [cat, score] of Object.entries(state.data.categories)) {
          if (score > maxCatScore) {
            maxCatScore = score;
            topCat = cat;
          }
        }
        state.currentCategory = topCat;

        // Calculate total score for Intent Level
        const totalScore = Object.values(state.data.categories).reduce((a, b) => a + b, 0);
        
        if (totalScore >= 15) {
          state.currentIntentLevel = 'HIGH';
        } else if (totalScore >= 5) {
          state.currentIntentLevel = 'MEDIUM';
        } else {
          state.currentIntentLevel = 'LOW';
        }
        
        log(`Intent Level: ${state.currentIntentLevel}, Top Category: ${state.currentCategory} (Score: ${maxCatScore})`);
      }
    };

    // 3. BehaviorTrigger
    const BehaviorTrigger = {
      init() {
        this.setupActivityTracking();
        this.setupExitIntent();
        this.startInactivityTimer();
      },

      setupActivityTracking() {
        const updateActivity = throttle(() => {
          state.lastActivityTime = Date.now();
          if (state.lastCloseTime && !state.isModalOpen && !state.hasInteractedSinceClose) {
            state.hasInteractedSinceClose = true;
            log('Nova interação significativa detectada após fechamento do popup.');
          }
        }, 500);

        window.addEventListener('mousemove', updateActivity);
        window.addEventListener('scroll', updateActivity, { passive: true });
        window.addEventListener('keydown', updateActivity);
        window.addEventListener('click', updateActivity);
        window.addEventListener('touchstart', updateActivity, { passive: true });
        window.addEventListener('touchmove', updateActivity, { passive: true });
        window.addEventListener('pointermove', updateActivity, { passive: true });
        window.addEventListener('wheel', updateActivity, { passive: true });
      },

      startInactivityTimer() {
        setInterval(() => {
          if (state.isModalOpen || document.hidden) return;

          const now = Date.now();

          if (state.lastCloseTime) {
            const timeSinceClose = now - state.lastCloseTime;
            const cooldownLeft = 120000 - timeSinceClose;
            
            if (cooldownLeft > 0) {
              // Em cooldown
              // Para evitar flood no console, só logamos o cooldown a cada ~10s
              if (Math.floor(cooldownLeft / 1000) % 10 === 0) {
                 log(`Em cooldown. Restante: ${Math.floor(cooldownLeft / 1000)}s`);
              }
              return;
            }
            if (!state.hasInteractedSinceClose) {
              // Passou do cooldown mas sem nova interação
              return;
            }
          }

          const inactiveTime = now - state.lastActivityTime;
          const sessionTime = now - state.sessionStartTime;

          // Tempos de inatividade necessários
          const requiredInactiveTime = state.currentIntentLevel === 'HIGH' ? 8000 : 15000;
          
          if (inactiveTime > requiredInactiveTime && inactiveTime < requiredInactiveTime + 10000) {
            // 120000ms = 2 mins (tempo mínimo da primeira exibição se não for HIGH)
            const hasEnoughTime = sessionTime > 120000;
            this.evaluateTriggers('INACTIVITY', hasEnoughTime);
          }
        }, 2000); // Check a cada 2 segundos
      },

      setupExitIntent() {
        // Desktop only
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.addEventListener('mouseleave', (e) => {
            if (state.isModalOpen || document.hidden) return;
            if (state.lastCloseTime && (Date.now() - state.lastCloseTime < 120000 || !state.hasInteractedSinceClose)) return;

            if (e.clientY <= 0) {
              const sessionTime = Date.now() - state.sessionStartTime;
              const hasEnoughTime = sessionTime > 120000;
              this.evaluateTriggers('EXIT_INTENT', hasEnoughTime);
            }
          });
        }
      },

      evaluateTriggers(triggerSource, hasEnoughSessionTime) {
        if (state.isModalOpen) return;

        const level = state.currentIntentLevel;

        let shouldShow = false;

        if (level === 'HIGH') {
          shouldShow = true; // High intent sempre mostra quando há gatilho
        } else if (level === 'MEDIUM' && hasEnoughSessionTime) {
          shouldShow = true; // Medium intent precisa de tempo de navegação
        }

        if (shouldShow) {
          log(`Exibição permitida. Motivo: Gatilho de ${triggerSource} atingido com intenção ${level}.`);
          RecommendationEngine.prepareAndShow();
        }
      }
    };

    // 4 & 5 & 6. RecommendationEngine & Popup
    const RecommendationEngine = {
      async prepareAndShow() {
        if (state.isModalOpen) return;
        state.isModalOpen = true;

        const { products } = state.data;
        const productsArray = Object.entries(products).map(([handle, data]) => ({ handle, ...data }));
        
        // Ordena produtos por score e visualizações
        productsArray.sort((a, b) => b.score - a.score || b.views - a.views);

        const maxCards = 3;
        const exactProducts = productsArray.slice(0, maxCards);
        
        const titleEl = document.getElementById('nyna-intent-title');
        const descEl = document.getElementById('nyna-intent-desc');

        // Mantém o texto fixo conforme a imagem
        if (titleEl) titleEl.textContent = 'Escolhas que combinam com você';
        if (descEl) descEl.textContent = 'Reunimos as peças que mais chamaram sua atenção.';

        RecommendationPopup.open();

        try {
          const grid = document.getElementById('nyna-intent-grid');
          const loading = document.getElementById('nyna-intent-loading');
          grid.innerHTML = '';
          
          let fetchedHTML = '';
          
          // 1. Fetch exact products by handle
          const fetchPromises = exactProducts.map(p => 
            fetch(`/products/${p.handle}?section_id=intent-recommendations-card`)
              .then(res => res.text())
              .then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const card = doc.querySelector('.shopify-section');
                return card ? card.innerHTML : '';
              })
              .catch(() => '')
          );

          const exactResults = await Promise.all(fetchPromises);
          fetchedHTML += exactResults.join('');

          // 2. Fetch related products via Recommendations API to fill up to 3
          if (exactProducts.length > 0) {
            const topProductId = exactProducts[0].id;
            const needed = maxCards - exactProducts.length;
            if (needed > 0) {
              const recRes = await fetch(`/recommendations/products?product_id=${topProductId}&limit=${needed + 2}&section_id=intent-recommendations`);
              if (recRes.ok) {
                const recHtml = await recRes.text();
                const doc = new DOMParser().parseFromString(recHtml, 'text/html');
                const cards = doc.querySelectorAll('.shopify-section .intent-minimal-card');
                
                let added = 0;
                cards.forEach(card => {
                  // Previne duplicidade simples verificando hrefs
                  const href = card.querySelector('a')?.getAttribute('href');
                  if (href && !fetchedHTML.includes(href) && added < needed) {
                    fetchedHTML += card.outerHTML;
                    added++;
                  }
                });
              }
            }
          }

          loading.style.display = 'none';
          grid.innerHTML = fetchedHTML;
          grid.style.display = 'flex';

          // Remove o bloqueio de apenas 1 por sessão, para permitir reabertura futura
          // sessionStorage.setItem(SESSION_KEY, 'true');
          // state.hasShownThisSession = true;

          // Inicia carrossel automático
          let autoScrollInterval;
          const startAutoScroll = () => {
            if (autoScrollInterval) clearInterval(autoScrollInterval);
            autoScrollInterval = setInterval(() => {
              const card = grid.querySelector('.intent-minimal-card');
              if (!card) return;
              const cardWidth = card.offsetWidth + parseInt(window.getComputedStyle(grid).gap || 24);
              if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 10) {
                grid.scrollTo({ left: 0, behavior: 'smooth' });
              } else {
                grid.scrollBy({ left: cardWidth, behavior: 'smooth' });
              }
            }, 3000);
          };
          const stopAutoScroll = () => clearInterval(autoScrollInterval);

          if (grid.querySelectorAll('.intent-minimal-card').length > maxCards) {
            startAutoScroll();
            grid.addEventListener('mouseenter', stopAutoScroll);
            grid.addEventListener('mouseleave', startAutoScroll);
            grid.addEventListener('touchstart', stopAutoScroll);
          }

        } catch (err) {
          log('Error fetching recommendations', err);
          RecommendationPopup.close(); // Close on failure
        }
      }
    };

    const RecommendationPopup = {
      open() {
        const engine = document.getElementById('nyna-intent-engine');
        
        // Compensate for scrollbar to prevent layout shift
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.setProperty('--scrollbar-compensate', `${scrollbarWidth}px`);
        document.body.classList.add('nyna-intent-open');

        engine.classList.add('is-active');
        engine.setAttribute('aria-hidden', 'false');
        
        // Accessibility Focus Trap
        const closeBtn = document.querySelector('.nyna-intent-close');
        if (closeBtn) closeBtn.focus();
        
        document.addEventListener('keydown', this.handleEsc);
      },
      
      close() {
        const engine = document.getElementById('nyna-intent-engine');
        engine.classList.remove('is-active');
        engine.setAttribute('aria-hidden', 'true');
        state.isModalOpen = false;
        
        document.body.style.removeProperty('--scrollbar-compensate');
        document.body.classList.remove('nyna-intent-open');
        
        // Cooldown Logic
        state.lastCloseTime = Date.now();
        state.hasInteractedSinceClose = false;
        sessionStorage.setItem('nyna_last_close', state.lastCloseTime);
        log('Popup closed. Cooldown initiated.');
        
        document.removeEventListener('keydown', this.handleEsc);
      },
      
      handleEsc(e) {
        if (e.key === 'Escape') {
          RecommendationPopup.close();
        }
      },

      setupListeners() {
        document.querySelectorAll('[data-intent-close]').forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        });
      }
    };

    // Initialize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        IntentTracker.init();
        BehaviorTrigger.init();
        RecommendationPopup.setupListeners();
      });
    } else {
      IntentTracker.init();
      BehaviorTrigger.init();
      RecommendationPopup.setupListeners();
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Event delegation for Add to Cart buttons
    document.body.addEventListener('click', function(e) {
      const btn = e.target.closest('.product-card__add-to-cart');
      if (!btn) return;
      
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      e.preventDefault();
      
      btn.setAttribute('disabled', 'disabled');
      const originalText = btn.textContent;
      btn.textContent = 'ADICIONANDO...';

      const body = {
        id: variantId,
        quantity: 1,
        sections: [],
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(res => {
        if (!res.ok) throw new Error('Erro ao adicionar');
        return res.json();
      })
      .then(() => {
        return fetch(window.location.href);
      })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update Cart Drawer
        const newDrawer = doc.querySelector('[data-cart-drawer]');
        const currentDrawer = document.querySelector('[data-cart-drawer]');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          // Re-bind close event
          const closeBtn = currentDrawer.querySelector('[data-cart-close]');
          if (closeBtn) {
            closeBtn.addEventListener('click', function(ev) {
              ev.preventDefault();
              if (window.closeCart) window.closeCart();
            });
          }
        }

        // Update Cart Count Bubble
        const newBubble = doc.querySelector('.site-header__cart-count');
        const currentCart = document.querySelector('.site-header__cart');
        if (currentCart) {
          const currentBubble = currentCart.querySelector('.site-header__cart-count');
          if (newBubble) {
            if (currentBubble) {
              currentBubble.outerHTML = newBubble.outerHTML;
            } else {
              currentCart.insertAdjacentHTML('afterbegin', newBubble.outerHTML);
            }
          } else if (currentBubble) {
            currentBubble.remove();
          }
        }

        // Open Cart Drawer
        if (window.openCart) window.openCart();
      })
      .catch(err => {
        console.error('Erro ao adicionar ao carrinho:', err);
        alert('Não foi possível adicionar este produto à sacola.');
      })
      .finally(() => {
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
      });
    });

    // Handle interactive size selection in product card
    document.body.addEventListener('click', function(e) {
      const sizeBtn = e.target.closest('.product-card__size-btn');
      if (!sizeBtn) return;
      
      const card = sizeBtn.closest('.product-card');
      if (!card) return;
      
      const buttons = card.querySelectorAll('.product-card__size-btn');
      buttons.forEach(b => b.classList.remove('is-active'));
      sizeBtn.classList.add('is-active');
      
      const selectedSize = sizeBtn.dataset.value;
      const jsonEl = card.querySelector('.product-card-variants-json');
      if (!jsonEl) return;
      
      try {
        const variants = JSON.parse(jsonEl.textContent);
        const optionIndex = parseInt(sizeBtn.dataset.optionIndex, 10);
        
        // Find variant that matches the selected size and is available
        const matchedVariant = variants.find(v => v.options[optionIndex] === selectedSize && v.available);
        
        const addToCartBtn = card.querySelector('.product-card__add-to-cart');
        if (matchedVariant && addToCartBtn) {
          addToCartBtn.dataset.variantId = matchedVariant.id;
          addToCartBtn.removeAttribute('disabled');
          addToCartBtn.textContent = 'ADICIONAR A SACOLA';
        } else if (addToCartBtn) {
          addToCartBtn.setAttribute('disabled', 'disabled');
          addToCartBtn.textContent = 'ESGOTADO';
        }
      } catch (err) {
        console.error('Error parsing variants in card:', err);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    function getCartEndpoint(path, params) {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var url = root.replace(/\/$/, '/') + 'cart/' + path;

      if (params) {
        url += '?' + params.toString();
      }

      return url;
    }

    function normalizeZip(zip) {
      return zip.replace(/\D/g, '').slice(0, 8);
    }

    function formatZip(zip) {
      if (zip.length <= 5) return zip;
      return zip.slice(0, 5) + '-' + zip.slice(5);
    }

    function getBrazilProvinceName(uf) {
      var provinces = {
        AC: 'Acre',
        AL: 'Alagoas',
        AP: 'Amapa',
        AM: 'Amazonas',
        BA: 'Bahia',
        CE: 'Ceara',
        DF: 'Distrito Federal',
        ES: 'Espirito Santo',
        GO: 'Goias',
        MA: 'Maranhao',
        MT: 'Mato Grosso',
        MS: 'Mato Grosso do Sul',
        MG: 'Minas Gerais',
        PA: 'Para',
        PB: 'Paraiba',
        PR: 'Parana',
        PE: 'Pernambuco',
        PI: 'Piaui',
        RJ: 'Rio de Janeiro',
        RN: 'Rio Grande do Norte',
        RS: 'Rio Grande do Sul',
        RO: 'Rondonia',
        RR: 'Roraima',
        SC: 'Santa Catarina',
        SP: 'Sao Paulo',
        SE: 'Sergipe',
        TO: 'Tocantins'
      };

      return provinces[uf] || '';
    }

    function fetchAddress(zip) {
      return fetch('https://viacep.com.br/ws/' + zip + '/json/', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Nao foi possivel consultar o CEP.');
          return response.json();
        })
        .then(function (address) {
          if (address.erro) throw new Error('CEP nao encontrado.');
          return address;
        })
        .catch(function () {
          return null;
        });
    }

    function buildShippingParams(zip, address) {
      var params = new URLSearchParams();
      params.set('shipping_address[zip]', formatZip(zip));
      params.set('shipping_address[country]', 'Brazil');

      if (address && address.uf) {
        params.set('shipping_address[province]', getBrazilProvinceName(address.uf));
      }

      if (address && address.localidade) {
        params.set('shipping_address[city]', address.localidade);
      }

      return params;
    }

    function formatRatePrice(rate) {
      if (rate.price === '0.00' || rate.price === 0) return 'Grátis';
      return Number(rate.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function renderRates(list, rates) {
      list.innerHTML = '';

      rates.forEach(function (rate) {
        var item = document.createElement('li');
        var name = document.createElement('span');
        var price = document.createElement('span');

        item.className = 'shipping-calculator__rate';
        name.textContent = rate.presentment_name || rate.name || rate.code || 'Frete';
        price.className = 'shipping-calculator__price';
        price.textContent = formatRatePrice(rate);

        item.appendChild(name);
        item.appendChild(price);
        list.appendChild(item);
      });
    }

    function pollRates(params, attempt) {
      return fetch(getCartEndpoint('async_shipping_rates.json', params), {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Nao foi possivel calcular o frete.');
          return response.json();
        })
        .then(function (data) {
          if (data && data.shipping_rates) return data.shipping_rates;
          if (attempt >= 8) throw new Error('O cálculo demorou mais que o esperado. Tente novamente.');

          return new Promise(function (resolve) {
            window.setTimeout(resolve, 700);
          }).then(function () {
            return pollRates(params, attempt + 1);
          });
        });
    }

    function getRatesDirectly(params) {
      return fetch(getCartEndpoint('shipping_rates.json', params), {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Nao foi possivel calcular o frete.');
          return response.json();
        })
        .then(function (data) {
          return data && data.shipping_rates ? data.shipping_rates : [];
        });
    }

    if (window.shippingCalculatorReady) return;
    window.shippingCalculatorReady = true;

    function calculateShipping(calculator) {
      var input = calculator.querySelector('[data-shipping-zip]');
      var message = calculator.querySelector('[data-shipping-message]');
      var ratesList = calculator.querySelector('[data-shipping-rates]');
      var button = calculator.querySelector('[data-shipping-button]');

      if (!input || !message || !ratesList || !button) return;

      var zip = normalizeZip(input.value);
      ratesList.innerHTML = '';

      if (zip.length !== 8) {
        message.textContent = 'Informe um CEP válido com 8 números.';
        return;
      }

      button.disabled = true;
      message.textContent = 'Calculando frete...';

      fetchAddress(zip)
        .then(function (address) {
          var params = buildShippingParams(zip, address);

          return fetch(getCartEndpoint('prepare_shipping_rates.json', params), {
            method: 'POST',
            headers: { Accept: 'application/json' }
          })
            .then(function (response) {
              if (!response.ok && response.status !== 202) throw new Error('Nao foi possivel iniciar o calculo.');
              return pollRates(params, 0);
            })
            .catch(function () {
              return getRatesDirectly(params);
            });
        })
        .then(function (rates) {
          if (!rates.length) {
            message.textContent = 'Nenhuma opcao de frete foi encontrada para este CEP.';
            return;
          }

          message.textContent = 'Opcoes disponiveis:';
          renderRates(ratesList, rates);
        })
        .catch(function (error) {
          console.warn('Shipping calculator error:', error);
          message.textContent = 'Nao foi possivel calcular o frete agora. Confira o CEP ou tente no checkout.';
        })
        .finally(function () {
          button.disabled = false;
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-shipping-button]');
      if (!button) return;

      event.preventDefault();

      var calculator = button.closest('[data-shipping-calculator]');
      if (calculator) {
        calculateShipping(calculator);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        var input = event.target.closest('[data-shipping-zip]');
        if (input) {
          event.preventDefault();
          var calculator = input.closest('[data-shipping-calculator]');
          if (calculator) {
            calculateShipping(calculator);
          }
        }
      }
    });

    document.addEventListener('input', function (event) {
      if (!event.target.matches('[data-shipping-zip]')) return;
      event.target.value = normalizeZip(event.target.value);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
